export default __webpack_public_path__ + "static/media/vision.56331cd9.jpg";